"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "sso-container"
  }, [_c("div", {
    staticClass: "loading"
  }, [_c("div", {
    staticClass: "spinner"
  }), _c("p", [_vm._v("正在登录中...")])])]);
}];
render._withStripped = true;